export default __webpack_public_path__ + "static/media/chargebee-icon-orange.c2f29a79.png";